/* Xperts4x4 – hero dynamique : diaporama, mots tournants, compteurs, ouverture du sélecteur véhicule. */
(function () {
  if (customElements.get('x4x-hero')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  customElements.define('x4x-hero', class extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelectorAll('.x4x-hero__slide');
      this.dots = this.querySelectorAll('[data-dot]');
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 6000;
      this.style.setProperty('--x4x-int', this.interval + 'ms');
      this.dots.forEach(function (d) { d.addEventListener('click', function () { this.show(+d.dataset.dot); this.restart(); }.bind(this)); }, this);
      if (this.slides.length > 1 && !reduce) this.restart();
      this.addEventListener('mouseenter', function () { clearInterval(this.timer); }.bind(this));
      this.addEventListener('mouseleave', function () { if (this.slides.length > 1 && !reduce) this.restart(); }.bind(this));
      this.rotate();
      this.count();
      var cta = this.querySelector('[data-open-vehicle]');
      if (cta && (cta.getAttribute('href') === '#' || cta.getAttribute('href') === '')) cta.addEventListener('click', this.openVehicle);
    }
    disconnectedCallback() { clearInterval(this.timer); clearInterval(this.wordTimer); }
    restart() { clearInterval(this.timer); this.timer = setInterval(function () { this.show((this.index + 1) % this.slides.length); }.bind(this), this.interval); }
    show(i) {
      this.slides[this.index].classList.remove('is-active');
      if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');
      this.index = i;
      var s = this.slides[i], img = s.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
      s.classList.add('is-active');
      if (this.dots[i]) { var d = this.dots[i]; d.classList.remove('is-active'); void d.offsetWidth; d.classList.add('is-active'); }
    }
    rotate() {
      var host = this.querySelector('.x4x-hero__rotator');
      if (!host || reduce) return;
      var words = host.dataset.words.split('|').filter(Boolean), el = host.querySelector('[data-word]'), k = 0;
      if (words.length < 2) return;
      this.wordTimer = setInterval(function () {
        el.classList.add('is-out');
        setTimeout(function () { k = (k + 1) % words.length; el.textContent = words[k]; el.classList.remove('is-out'); }, 350);
      }, 2600);
    }
    count() {
      var nums = this.querySelectorAll('[data-count]');
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var el = e.target, end = parseInt(el.dataset.count, 10);
          if (isNaN(end) || String(end) !== el.dataset.count.trim()) return;
          var t0 = performance.now(), fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr');
          (function step(t) {
            var p = Math.min(1, (t - t0) / 1400), v = Math.round(end * (1 - Math.pow(1 - p, 3)));
            el.textContent = fmt.format(v);
            if (p < 1) requestAnimationFrame(step);
          })(t0);
        });
      }, { threshold: .4 });
      nums.forEach(function (n) { io.observe(n); });
    }
    openVehicle(e) {
      var bar = document.querySelector('x4x-vehicle-bar');
      if (!bar) return;
      e.preventDefault();
      bar.classList.add('is-open');
      var change = bar.querySelector('[data-saved]:not([hidden]) [data-change]');
      if (change) change.click();
      bar.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var first = bar.querySelector('[data-level="1"]');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
    }
  });
})();
